import { arrayValidator, emailValidator } from '@lucidlink/dto/validation';
import { remapZodErrors } from '@lucidlink/uicore';
export const inviteEmailFiltersValidator = arrayValidator({
    element: emailValidator({
        requiredError: 'invitation.emailFilters.email.required',
        formatError: 'invitation.emailFilters.email.format',
    }),
    minLength: {
        min: 1,
        error: 'invitation.emailFilters.empty',
    },
    requiredError: 'invitation.emailFilters.required',
});
export const inviteEmailValidation = (values) => {
    const result = inviteEmailFiltersValidator.safeParse(values);
    return {
        isValid: result.success,
        errors: result.success ? [] : remapZodErrors(result.error.issues),
    };
};
// Check if the number of provided emails in the TagInput exceeds the available member slots
export const membersCountValidation = (availableSlots) => {
    return (values) => {
        if (values.length > availableSlots) {
            const errors = [];
            for (let index = availableSlots; index < values.length; index++) {
                errors.push({
                    code: 'invitation.limitExceeded',
                    path: [index.toString()],
                    message: '',
                });
            }
            return {
                isValid: false,
                errors,
            };
        }
        else {
            return {
                isValid: true,
                errors: [],
            };
        }
    };
};
